module.exports = __webpack_public_path__ + "Kanit-Thin.a19557dc495c81c4a3d3.ttf";


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/assets/fonts/Kanit-Thin.ttf
// module id = ../../../../../src/assets/fonts/Kanit-Thin.ttf
// module chunks = styles